export const TRIVIA_BACKGROUND_PRESETS = [
    { id: "midnight-violet", label: "Midnight Violet", colors: ["#1e1b4b", "#5b21b6"] },
    { id: "deep-ocean", label: "Deep Ocean", colors: ["#0c4a6e", "#0891b2"] },
    { id: "crimson-stage", label: "Crimson Stage", colors: ["#450a0a", "#b91c1c"] },
    { id: "emerald-arena", label: "Emerald Arena", colors: ["#022c22", "#059669"] },
    { id: "sunset-gold", label: "Sunset Gold", colors: ["#7c2d12", "#d97706"] },
    { id: "electric-magenta", label: "Electric Magenta", colors: ["#4a044e", "#c026d3"] },
    { id: "slate-spotlight", label: "Slate Spotlight", colors: ["#0f172a", "#334155"] },
    { id: "amber-nightfall", label: "Amber Nightfall", colors: ["#1c1917", "#ea580c"] },
];
export const TRIVIA_BACKGROUND_PRESET_IDS = TRIVIA_BACKGROUND_PRESETS.map((preset) => preset.id);
export function triviaBackgroundPreset(presetId) {
    return TRIVIA_BACKGROUND_PRESETS.find((preset) => preset.id === presetId) ?? null;
}
//# sourceMappingURL=trivia-background-presets.js.map